import {apiDelete, apiGet, apiPost, apiPut} from "./api";

export interface DepartmentJobMapping {
    JobCode: string;
    JobName: string;
    ParentJobCode?: string;
    ParentJobName?: string;
    EffectiveStartDate: number;
    EffectiveEndDate: number;
    DepartmentCode?: string;
    CreatedDate: number;
    LastModifiedDate: number;
}

export interface DepartmentJobMappingSearchParams {
    JobCode?: string;
    ParentJobCode?: string;
    DepartmentCode?: string;
    ShowDisabled?: boolean;
}

export interface DepartmentJobMappingInput {
    JobCode: string;
    JobName: string;
    ParentJobCode?: string;
    ParentJobName?: string;
    EffectiveStartDate: number;
    EffectiveEndDate?: number;
    DepartmentCode?: string;
}

export const getDepartmentJobMappings = async (
    params: DepartmentJobMappingSearchParams = {}
): Promise<DepartmentJobMapping[]> => {
    return await apiGet(`/job-department-mapping`, {
        jobCode: params.JobCode,
        parentJobCode: params.ParentJobCode,
        departmentCode: params.DepartmentCode,
        showDisabled: params.ShowDisabled
    });
};

export const createDepartmentJobMapping = async (
    data: DepartmentJobMappingInput
): Promise<DepartmentJobMapping> => {
    return await apiPost(`/job-department-mapping`, data);
};


export const updateDepartmentJobMapping = async (
    previousJobCode: string,
    previousDepartmentCode: string,
    data: DepartmentJobMappingInput
): Promise<DepartmentJobMapping> => {
    return await apiPut(`/job-department-mapping`, {
        ...data,
        PreviousJobCode: previousJobCode,
        PreviousDepartmentCode: previousDepartmentCode
    });
};

export const deleteDepartmentJobMapping = async (jobCode: string, departmentCode: string): Promise<void> => {
    await apiDelete(`/job-department-mapping`, {JobCode: jobCode, DepartmentCode: departmentCode});
};

export interface CsvImportUploadResult {
    success: boolean;
    message: string;
}

export const importDepartmentJobMappingCsv = async (fileContentBase64: string): Promise<CsvImportUploadResult> => {
    return await apiPost(`/job-department-mapping/import`, {fileContent: fileContentBase64});
};

export interface DownloadImportResultResponse {
    fileName: string;
    fileContent: string;
}

export const downloadDepartmentJobMappingImportResult = async (key: string): Promise<DownloadImportResultResponse> => {
    return await apiGet(`/job-department-mapping/import/result`, {key});
};
